import appSelectComponent from './app-select.component';

const appSelectModule = angular.module('appSelect', [
])
  .component('appSelect', appSelectComponent)
  .name;

export default appSelectModule;
